/**
 * @file 下拉筛选组件集合
 * @author alfielv
 */
import Select from './Select';
import SelectTree from './SelectTree';
import DatePicker from './DatePicker';
import NumberRange from './NumberRange';
export default {
  select: Select,
  'select-tree': SelectTree,
  'date-picker': DatePicker,
  'number-range': NumberRange
};